/**
 * Retorna el primer valor disponible. Si el parámetro es una array retorna el
 * primer elemento (undefined si es un array vacío). En cualquier otro caso
 * retora el mismo valor.
 */
export default function <T>(value: T | T[]): T | undefined {
  return Array.isArray(value) ? value[0] : value;
}
